export const ASSESSMENT_REGISTRY = [
  {
    key: 'aptitude',
    label: 'MindEdge Aptitude Test',
    subtitle: '5 Sections · 50 Questions · ~45 min',
    description: 'Master quantitative reasoning, logical thinking, verbal ability, data interpretation, and abstract pattern recognition aligned to industry-standard hiring assessment patterns.',
    route: '/assessment/aptitude/verify',
    enabled: true,
    disabled: false,
    color: 'amber',
    icon: 'Brain',
    badge: 'Popular'
  },
  {
    key: 'cognitive',
    label: 'NeuroPeak Cognitive Battery',
    subtitle: '5 Sections · 50 Questions · ~40 min',
    description: 'Scientifically validated cognitive battery measuring working memory, processing speed, fluid reasoning, sustained attention, and spatial intelligence trusted by leading hiring teams.',
    route: '/assessment/cognitive/verify',
    enabled: true,
    disabled: false,
    color: 'purple',
    icon: 'Zap',
    badge: 'New'
  },
  {
    key: 'skill',
    label: 'ProEdge Skill Assessment',
    subtitle: '5 Sections · 50 Questions · ~50 min',
    description: 'Comprehensive professional skills evaluation across technical knowledge, analytical thinking, business communication, leadership dynamics, and workplace ethics for professional and entry-level career readiness.',
    route: '/assessment/skill/verify',
    enabled: true,
    disabled: false,
    color: 'emerald',
    icon: 'Award',
    badge: 'Professional'
  },
  {
    key: 'mega',
    label: 'Apex All-in-One Mega Bundle',
    subtitle: '7 Sections · 70 Questions · ~75 min',
    description: 'Comprehensive hiring-readiness battery combining aptitude, cognitive, skill, coding fundamentals, and situational judgement.',
    route: '/assessment/mega/verify',
    enabled: true,
    disabled: false,
    color: 'amber',
    icon: 'Crown',
    badge: 'Best Value'
  },
  {
    key: 'bigfive',
    label: 'Big Five Personality',
    subtitle: '5 Traits · 50 Questions · ~25 min',
    description: 'Discover your core personality dimensions across openness, conscientiousness, extraversion, agreeableness, and neuroticism.',
    route: '/assessment/bigfive',
    enabled: false, // DISABLED: Big Five - temporarily unavailable
    disabled: true,
    color: 'purple',
    icon: 'Brain'
  },
  {
    key: 'productivity',
    label: 'Productivity Assessment',
    subtitle: '4 Sections · 40 Questions · ~30 min',
    description: 'Identify your productivity strengths, time management style, and focus patterns.',
    route: '/assessment/productivity',
    enabled: true,
    disabled: false,
    color: 'blue',
    icon: 'TrendingUp'
  },
  {
    key: 'extended',
    label: 'Extended Assessment',
    subtitle: 'Multi-domain · ~45 min',
    description: 'A comprehensive multi-domain psychometric evaluation.',
    route: '/assessment/extended',
    enabled: false, // DISABLED: Extended - temporarily unavailable
    disabled: true,
    color: 'amber',
    icon: 'ClipboardList'
  },
  {
    key: 'edutech',
    label: 'Edutech Assessment',
    subtitle: '5 Sections · 30 random questions per section',
    description: 'Evaluate teaching competency across pedagogical foundations, classroom management, digital literacy, curriculum knowledge, and education policy.',
    route: '/assessment/edutech',
    enabled: true,
    disabled: false,
    color: 'indigo',
    icon: 'GraduationCap',
    badge: 'New'
  },
  {
    key: 'salesforce',
    label: 'Salesforce AI WorkScore',
    subtitle: '5 Sections · Random 10/12 per section · ~90 min',
    description: 'Field sales decision assessment focused on prospecting, negotiation, follow-ups, and target execution.',
    route: '/assessment/salesforce/verify',
    enabled: true,
    disabled: false,
    color: 'blue',
    icon: 'Target',
    badge: 'WorkScore'
  },
  {
    key: 'customercare',
    label: 'CustomerCare AI WorkScore',
    subtitle: '5 Sections · Random 10/12 per section · ~90 min',
    description: 'Customer support judgment assessment covering empathy, complaint handling, retention, and pressure professionalism.',
    route: '/assessment/customercare/verify',
    enabled: true,
    disabled: false,
    color: 'green',
    icon: 'Headphones',
    badge: 'WorkScore'
  },
  {
    key: 'callingsales',
    label: 'CallingSales AI WorkScore',
    subtitle: '5 Sections · Random 10/12 per section · ~90 min',
    description: 'Inside sales calling assessment for openings, objection handling, follow-up quality, and call conversion behavior.',
    route: '/assessment/callingsales/verify',
    enabled: true,
    disabled: false,
    color: 'amber',
    icon: 'PhoneCall',
    badge: 'WorkScore'
  },
  {
    key: 'feetonstreet',
    label: 'FeetOnStreet AI WorkScore',
    subtitle: '5 Sections · Random 10/12 per section · ~90 min',
    description: 'Field promotion and territory execution assessment for resilience, adaptability, public interaction, and target persistence.',
    route: '/assessment/feetonstreet/verify',
    enabled: true,
    disabled: false,
    color: 'indigo',
    icon: 'MapPinned',
    badge: 'Premium'
  }
];

export const activeAssessments = ASSESSMENT_REGISTRY.filter((a) => a.enabled && !a.disabled);
